import differenceInMillisecondsFn from 'date-fns/differenceInMilliseconds';

export const differenceInMilliseconds = differenceInMillisecondsFn;

